import _ from 'lodash';
import React from 'react';

export function isPromise(promise) {
	return promise ? _.isFunction(promise.finally) : false;
}

export const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

export const isServerError = (status) => status === 500 || status === 501 || status === 502 || status === 503 || status === 504 || status === 0;

const countryCodes = [
	'ad',
	'ae',
	'af',
	'ag',
	'ai',
	'al',
	'am',
	'ao',
	'aq',
	'ar',
	'as',
	'at',
	'au',
	'aw',
	'ax',
	'az',
	'ba',
	'bb',
	'bd',
	'be',
	'bf',
	'bg',
	'bh',
	'bi',
	'bj',
	'bl',
	'bm',
	'bn',
	'bo',
	'bq',
	'br',
	'bs',
	'bt',
	'bv',
	'bw',
	'by',
	'bz',
	'ca',
	'cc',
	'cd',
	'cf',
	'cg',
	'ch',
	'ci',
	'ck',
	'cl',
	'cm',
	'cn',
	'co',
	'cr',
	'cu',
	'cv',
	'cw',
	'cx',
	'cy',
	'cz',
	'de',
	'dj',
	'dk',
	'dm',
	'do',
	'dz',
	'ec',
	'ee',
	'eg',
	'eh',
	'er',
	'es',
	'et',
	'eu',
	'fi',
	'fj',
	'fk',
	'fm',
	'fo',
	'fr',
	'ga',
	'gb-eng',
	'gb-nir',
	'gb-sct',
	'gb-wls',
	'gb',
	'gd',
	'ge',
	'gf',
	'gg',
	'gh',
	'gi',
	'gl',
	'gm',
	'gn',
	'gp',
	'gq',
	'gr',
	'gs',
	'gt',
	'gu',
	'gw',
	'gy',
	'hk',
	'hm',
	'hn',
	'hr',
	'ht',
	'hu',
	'id',
	'ie',
	'il',
	'im',
	'in',
	'io',
	'iq',
	'ir',
	'is',
	'it',
	'je',
	'jm',
	'jo',
	'jp',
	'ke',
	'kg',
	'kh',
	'ki',
	'km',
	'kn',
	'kp',
	'kr',
	'kw',
	'ky',
	'kz',
	'la',
	'lb',
	'lc',
	'li',
	'lk',
	'lr',
	'ls',
	'lt',
	'lu',
	'lv',
	'ly',
	'ma',
	'mc',
	'md',
	'me',
	'mf',
	'mg',
	'mh',
	'mk',
	'ml',
	'mm',
	'mn',
	'mo',
	'mp',
	'mq',
	'mr',
	'ms',
	'mt',
	'mu',
	'mv',
	'mw',
	'mx',
	'my',
	'mz',
	'na',
	'nc',
	'ne',
	'nf',
	'ng',
	'ni',
	'nl',
	'no',
	'np',
	'nr',
	'nu',
	'nz',
	'om',
	'pa',
	'pe',
	'pf',
	'pg',
	'ph',
	'pk',
	'pl',
	'pm',
	'pn',
	'pr',
	'ps',
	'pt',
	'pw',
	'py',
	'qa',
	're',
	'ro',
	'rs',
	'ru',
	'rw',
	'sa',
	'sb',
	'sc',
	'sd',
	'se',
	'sg',
	'sh',
	'si',
	'sj',
	'sk',
	'sl',
	'sm',
	'sn',
	'so',
	'sr',
	'ss',
	'st',
	'sv',
	'sx',
	'sy',
	'sz',
	'tc',
	'td',
	'tf',
	'tg',
	'th',
	'tj',
	'tk',
	'tl',
	'tm',
	'tn',
	'to',
	'tr',
	'tt',
	'tv',
	'tw',
	'tz',
	'ua',
	'ug',
	'um',
	'un',
	'unknown',
	'us',
	'uy',
	'uz',
	'va',
	'vc',
	've',
	'vg',
	'vi',
	'vn',
	'vu',
	'wf',
	'ws',
	'ye',
	'yt',
	'za',
	'zm',
	'zw'
];
export const trafficSourcesTitles = {
	ADVERTISING: 'The viewer was referred to the video by an advertisement.',
	ANNOTATION: 'Viewers reached the video by clicking on an annotation in another video.',
	CAMPAIGN_CARD:
		'Views originated from claimed, user-uploaded videos that the content owner used to promote the viewed content.',
	END_SCREEN: ' The views were referred from the end screen of another video.',
	EXT_URL: 'The video views were referred from a link on another website.',
	NO_LINK_EMBEDDED: 'The video was embedded on another website when it was viewed.',
	NO_LINK_OTHER: 'YouTube did not identify a referrer for the traffic.',
	NOTIFICATION: 'The video views were referred from an email or notification from YouTube.',
	PLAYLIST: 'The video views occurred while the video was being played as part of a playlist.',
	PROMOTED: 'The video views were referred from an unpaid YouTube promotion.',
	RELATED_VIDEO: 'The video views were referred from a related video listing on another video watch page.',
	SUBSCRIBER:
		'The video views were referred from feeds on the YouTube homepage or from YouTube subscription features.',
	YT_CHANNEL: 'The video views occurred on a channel page.',
	YT_OTHER_PAGE:
		'The video views were referred from a link other than a search result or related video link that appeared on a YouTube page.',
	YT_PLAYLIST_PAGE: 'The video views originated from a page that lists all of the videos in a playlist.',
	YT_SEARCH: 'The video views were referred from YouTube search results.'
};

export function countryImage(countryCode) {
	if (_.isString(countryCode)) {
		const lowered = countryCode.toLowerCase();
		if (_.includes(countryCodes, lowered)) {
			return `https://viewiq-ui-assets.s3.amazonaws.com/flags/${lowered}.svg`;
		}
	}
	return 'https://viewiq-ui-assets.s3.amazonaws.com/flags/unknown.svg';
}

export function generateAbbreviation(string) {
	if (!_.isString(string)) {
		return '';
	}
	return string
		.match(/\b([a-z])/gi)
		.join('')
		.toUpperCase();
}

export function areComponentsEqual(component1, component2) {
	// Simple shallow comparison for React Refresh compatibility
	return component1 === component2;
}

export function stringifyFileSize(number) {
	const oneKB = 1024;
	const oneMB = oneKB * oneKB;
	if (number < oneKB) {
		return number + 'bytes';
	} else if (number > oneKB && number < oneMB) {
		return (number / oneKB).toFixed(1) + 'KB';
	} else if (number > oneMB) {
		return (number / oneMB).toFixed(1) + 'MB';
	}
}

export function imageBase64ToBlob(img) {
	const data = atob(img.substring('data:image/jpeg;base64,'.length));
	const asArray = new Uint8Array(data.length);

	for (let i = 0, len = data.length; i < len; ++i) {
		asArray[i] = data.charCodeAt(i);
	}

	return new Blob([asArray.buffer], { type: 'image/png' });
}

export function sliceCountryData(data) {
	var keysSorted = Object.keys(data).sort(function (a, b) {
		return data[b] - data[a];
	});

	var sliced_data = keysSorted.slice(0, 10).map((key) => ({
		code: key,
		title: key,
		value: data[key]
	}));
	return sliced_data;
}

export const checkFileExtension = (filename, extension) => {
	return filename.split('.').pop() === extension;
};

export const checkCSVFile = (file) => {
	return file?.name?.split('.')?.pop() === 'csv';
};

export const checkIconFile = (file) => {
	const extension = file?.name?.split('.').pop();
	return extension === 'jpeg' || extension === 'jpg' || extension === 'png';
}

export const populateComscoreNodes = (treeData, nodeIDs) => {
	if (_.isEmpty(treeData) || _.isEmpty(nodeIDs)) return [];
	const nodesArray = [];
	const checkSelectedNodes = (node) => {
		_.each(node.children, (child) => {
			if (_.includes(nodeIDs, child.id)) nodesArray.push(child);
			else if (!_.isEmpty(child.children)) checkSelectedNodes(child);
		});
	};
	_.each(treeData['us'], (node) => {
		if (_.includes(nodeIDs, node.id)) nodesArray.push(node);
		else if (!_.isEmpty(node.children)) checkSelectedNodes(node);
	});
	return nodesArray;
};

export const createComscoreTreeStrings = (treeData, region) => {
	if (_.isEmpty(treeData)) return {};
	const stringsList = {};
	_.each(treeData[region], (nodeOne) => {
		// nodeOne (viewwing behaviours, finance, etc) is not a selectable node hence not added to the search
		if (!_.isEmpty(nodeOne.children)) {
			_.each(nodeOne.children, (nodeTwo) => {
				stringsList[`${nodeOne.value} > ${nodeTwo.value}`] = {
					value: nodeTwo.value,
					id: nodeTwo.id,
					parentNodes: [nodeOne]
				};
				if (!_.isEmpty(nodeTwo.children)) {
					_.each(nodeTwo.children, (nodeThree) => {
						stringsList[`${nodeOne.value} > ${nodeTwo.value} > ${nodeThree.value}`] = {
							value: nodeThree.value,
							id: nodeThree.id,
							parentNodes: [nodeOne, nodeTwo]
						};
						if (!_.isEmpty(nodeThree.children)) {
							_.each(nodeThree.children, (nodeFour) => {
								stringsList[
									`${nodeOne.value} > ${nodeTwo.value} > ${nodeThree.value} > ${nodeFour.value}`
								] = {
									value: nodeFour.value,
									id: nodeFour.id,
									parentNodes: [nodeOne, nodeTwo, nodeThree]
								};
							});
						}
					});
				}
			});
		}
	});
	return stringsList;
};

export const checkPureObject = (obj) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null;

export const isNumeric = (value) => /^-?\d+$/.test(value);

export const isValidDollarInput = (value) => {
	if (value === null || value === undefined || value === '') return true;
	const trimmed = String(value).replace(/,/g, '').trim();
	return !trimmed || /^\d*\.?\d{0,2}$/.test(trimmed);
};

export const getDollarInputDisplay = (inputByKey, key, cents, toDollars) => {
	if (Object.prototype.hasOwnProperty.call(inputByKey, key)) {
		return inputByKey[key];
	}
	const dollars = toDollars(cents);
	return dollars ?? '';
};

/**
 * Modern React hook for detecting clicks outside a component
 * Compatible with React 17+ and works with refs instead of element IDs
 *
 * @param {Object} ref - React ref object pointing to the element to monitor
 * @param {Function} handler - Callback function to execute when clicking outside
 * @param {Array} dependencies - Optional dependencies array for the effect
 * @returns {void}
 *
 * @example
 * // In a functional component
 * const popoverRef = useRef(null);
 * useClickOutside(popoverRef, () => setShowPopover(false));
 *
 * return <div ref={popoverRef}>Popover content</div>;
 */
export const useClickOutside = (ref, handler, dependencies = []) => {
	React.useEffect(() => {
		const listener = (event) => {
			// Do nothing if clicking ref's element or descendent elements
			if (!ref.current || ref.current.contains(event.target)) {
				return;
			}
			
			// If clicking on a popover opener, check if it's for a different popover
			const popoverOpener = event.target.closest('.popover-opener');
			if (popoverOpener) {
				const targetPopoverId = popoverOpener.getAttribute('data-popover-id');
				const currentPopoverId = ref.current?.id;
				
				// Close if clicking on a different popover opener OR the same opener (to toggle)
				if (targetPopoverId && targetPopoverId !== currentPopoverId) {
					handler(event);
					return;
				} else if (targetPopoverId === currentPopoverId) {
					// Same popover opener - let the component handle the toggle
					return;
				}
			}
			
			handler(event);
		};

		// Use mousedown and touchstart for better mobile support
		document.addEventListener('mousedown', listener);
		document.addEventListener('touchstart', listener);

		return () => {
			document.removeEventListener('mousedown', listener);
			document.removeEventListener('touchstart', listener);
		};
	}, [ref, handler, ...dependencies]);
};

// Forecasting
export const mapForecastingGraphData = (data) => {
	const apiData = !_.isEmpty(data[0]?.trend) ? data[0]?.trend : [];
	const formatTrendData = (trend) => {
		const monthData = {};
		const monthOrder = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];
		trend.forEach((yearObj) => {
			const year = yearObj.label;
			const months = yearObj.value;
			for (const monthKey in months) {
				const month = months[monthKey];
				const monthLabel = month.label;
				if (!monthData[monthLabel]) {
					monthData[monthLabel] = { name: monthLabel, Q: month.quarter };
				}
				monthData[monthLabel][year] = month.value;
				const quarterKey = `${year}_${month.quarter}`;
				monthData[monthLabel][quarterKey] = month.quarter_average;
				if (!monthData[monthLabel].Q) {
					monthData[monthLabel].Q = month.quarter;
				}
			}
		});
		const formattedData = Object.values(monthData);
		formattedData.sort((a, b) => monthOrder.indexOf(a.name) - monthOrder.indexOf(b.name));
		return formattedData;
	};
	const getAvailableYears = (trend) => {
		return trend.map((yearObj) => yearObj.label);
	};
	const chartKeys =  getAvailableYears(apiData);
	const chartLineColors = ['#E0301E','#0089EB','#68D391','#FFD979'];
	const getChartColors = (keys) => {
		return _.reduce(keys, (acc, key, i) => {
			acc[key] = chartLineColors[i];
			return acc;
		}, {});
	}
	return {
		keys: chartKeys,
		graphData: formatTrendData(apiData),
		yearsColors: getChartColors(chartKeys)
	};
};

export const findTitleKey = (array) => {
	const displayKeys = ['title', 'name', 'value'];
	const firstItem = array[0];
	const displayKey = displayKeys.find(key => key in firstItem);
	return displayKey;
}

/**
 * Legacy click outside handler for class components (deprecated)
 * @deprecated Use useClickOutside hook instead for better React 17 compatibility
 * @param {string} elementId - The ID of the element to check if clicked outside
 * @param {Function} onOutsideClick - Callback function to execute when clicking outside
 * @param {Object} options - Optional configuration
 * @returns {Object} - Object with addListener and removeListener methods
 */
export const createClickOutsideHandler = (elementId, onOutsideClick, options = {}) => {
	const { useContains = true, useRecursiveCheck = true } = options;
	
	let bodyClickHandler = null;
	
	const checkRecursively = (offsetParent, id) => {
		if (!offsetParent?.id) return false;
		if (offsetParent.id === id || offsetParent.id.includes(id)) return true;
		if (!_.isEmpty(offsetParent.offsetParent)) {
			return checkRecursively(offsetParent.offsetParent, id);
		}
		return false;
	};
	
	const addListener = () => {
		if (bodyClickHandler) return; // Prevent duplicate listeners
		
		bodyClickHandler = function(event) {
			const targetElement = useContains
				? document.getElementById(elementId)
				: document.querySelector(`#${elementId}`);
			
			if (!targetElement) return;
			
			const isClickInside = targetElement.contains(event.target);
			const isClickInParent = useRecursiveCheck && checkRecursively(event.target.offsetParent, elementId);
			const hasValidOffsetParent = event.target.offsetParent !== null;
			
			if (!isClickInside && !isClickInParent && hasValidOffsetParent) {
				onOutsideClick();
			}
		};
		
		// Use setTimeout to avoid React 17 event delegation issues
		setTimeout(() => {
			document.addEventListener('click', bodyClickHandler);
		}, 0);
	};
	
	const removeListener = () => {
		if (bodyClickHandler) {
			document.removeEventListener('click', bodyClickHandler);
			bodyClickHandler = null;
		}
	};
	
	return {
		addListener,
		removeListener
	};
};

export const formatInternationalCurrency = (currencyCode, amount, type = 'compact') => {
	const isCompact = type === 'compact';
	const numberParts = new Intl.NumberFormat('en-US', {
		notation: type,
		maximumFractionDigits: 2,
		minimumFractionDigits: isCompact ? 0 : 2
	}).formatToParts(amount);
	const currencyParts = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: currencyCode,
		currencyDisplay: 'symbol'
	}).formatToParts(amount);
	const currencyPart = _.find(currencyParts, { type: 'currency' });
	const isCurrencyCode = currencyPart?.value === currencyCode;
	const sign = _
		.filter(numberParts, ({ type }) => _.includes(['minusSign', 'plusSign'], type))
		.map(({ value }) => value)
		.join('');
	const number = _
		.filter(numberParts, ({ type }) => !_.includes(['minusSign', 'plusSign', 'literal'], type))
		.map(({ type, value }) => (type === 'compact' ? value.trim() : value))
		.join('');

	if (!currencyPart) {
		return `${sign}${number}`;
	}

	if (isCurrencyCode) {
		return `${sign}${number} ${currencyPart.value}`;
	}

	return `${sign}${currencyPart.value}${number}`;
};

export function getUrlOrigin(url) {
	if (!url) return null;
	try {
		return new URL(url).origin;
	} catch (_e) {
		return null;
	}
}
